export default "__VITE_ASSET__CuT0CXuk__"